import { render, staticRenderFns } from "./TheChangeCategoriesModal.vue?vue&type=template&id=58c23094&"
import script from "./TheChangeCategoriesModal.vue?vue&type=script&lang=js&"
export * from "./TheChangeCategoriesModal.vue?vue&type=script&lang=js&"
import style0 from "./TheChangeCategoriesModal.vue?vue&type=style&index=0&id=58c23094&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports